(() => {
  const selector = 'input[data-option-name="Frame (Final Size)"]';

  function isUnavailable(input) {
    return input.getAttribute('aria-disabled') === 'true' || input.dataset.optionAvailable === 'false';
  }

  function refreshFrameOptions() {
    const inputs = Array.from(document.querySelectorAll(selector));

    if (inputs.length === 0) return;

    inputs.forEach((input) => {
      const label = input.closest('label');
      if (label) label.hidden = isUnavailable(input);
    });

    const selected = inputs.find((input) => input.checked);
    if (selected && isUnavailable(selected)) {
      const firstAvailable = inputs.find((input) => !isUnavailable(input));
      if (firstAvailable) firstAvailable.click();
    }
  }

  let refreshScheduled = false;
  function scheduleRefresh() {
    if (refreshScheduled) return;
    refreshScheduled = true;
    requestAnimationFrame(() => {
      refreshScheduled = false;
      refreshFrameOptions();
    });
  }

  const observer = new MutationObserver(scheduleRefresh);
  observer.observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['aria-disabled', 'data-option-available', 'checked'],
  });

  document.addEventListener('change', scheduleRefresh, true);
  refreshFrameOptions();
})();
